import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexBetween,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow, DefaultTableTd } from '../../Zemplin/General/Table';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import { useState } from 'react';

export interface Props {
  order?: any;
  theme: any;
  color?: string;
}

function WatchingRow({ order, theme, color = '' }: Props) {
  // const { id, date, status, sumPrice, ordernr } = getOrderRowInfo(order);
  // const color = getOrderColor(status, theme);
  const [onStockActive, setOnStockActive] = useState(false);
  const [priceActive, setPriceActive] = useState(false);
  const [priceDownActive, setPriceDownActive] = useState(false);

  return (
    <StyledTableRow>
      <StyledTableTd>
        <FlexRowCenterVertical>
          <FlexCol>
            <Image
              width={56}
              height={56}
              alt={`Obrázok produktu`}
              src={'/images/icons/placeholder.svg'}
            />
          </FlexCol>
          <FlexCol>
            <ProductName
              color={color}
            >{`Jam Audio Double Chill čierny`}</ProductName>
            <ProductPlu>{`HMDHX-P404BK`}</ProductPlu>
          </FlexCol>
        </FlexRowCenterVertical>
      </StyledTableTd>
      <StyledTableTd>
        <IconRow>
          <SvgIcon
            icon={IconType.onStock}
            width={24}
            height={24}
            marginRight={13}
            fill={onStockActive ? '#36BF91' : '#DDDDDD'}
            /* tslint:disable-next-line:jsx-no-lambda */
            onClick={() => setOnStockActive(!onStockActive)}
            cursor={'pointer'}
            title={`${__('Keď bude tovar skladom')}`}
          />
          <SvgIcon
            icon={IconType.price}
            width={24}
            height={24}
            marginRight={13}
            fill={priceActive ? '#36BF91' : '#DDDDDD'}
            /* tslint:disable-next-line:jsx-no-lambda */
            onClick={() => setPriceActive(!priceActive)}
            cursor={'pointer'}
            title={`${__('Pri zmene ceny')}`}
          />
          <SvgIcon
            icon={IconType.priceDown}
            width={24}
            height={24}
            fill={priceDownActive ? '#36BF91' : '#DDDDDD'}
            /* tslint:disable-next-line:jsx-no-lambda */
            onClick={() => setPriceDownActive(!priceDownActive)}
            cursor={'pointer'}
            title={`${__('Pri znížení ceny')}`}
          />
        </IconRow>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText color={color} align={'center'}>{`24.12.2019`}</StatusText>
      </StyledTableTd>
      <StyledTableTd>
        <IconRow align={'center'}>
          <SvgIcon
            icon={IconType.edit}
            width={24}
            height={24}
            marginRight={13}
            fill={'#414141'}
            cursor={'pointer'}
            title={`${__('Upraviť')}`}
          />
          <SvgIcon
            icon={IconType.trash}
            width={24}
            height={24}
            fill={'#414141'}
            cursor={'pointer'}
            title={`${__('Odstrániť zo zoznamu')}`}
          />
        </IconRow>
      </StyledTableTd>
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)<{ align: string; maxWidth?: number }>`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: ${({ theme }) => theme.borders.primary};
  max-width: ${({ maxWidth }) => (maxWidth ? rem(maxWidth) : 'initial')};
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};
  background-color: ${({ theme }) => theme.colors.white};
  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const StatusText = styled(TextP)<{ color?: string; align?: string }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme, color }) =>
    color === 'red' ? theme.colors.dangerColor : theme.colors.textPrimary};
  font-weight: ${({ color }) => (color === 'red' ? '500' : '400')};
  text-align: ${({ align }) =>
    align === 'center' ? 'center' : align === 'right' ? 'right' : 'left'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ProductName = styled(TextP)`
  font-weight: 500;
`;

const ProductPlu = styled(TextP)`
  font-size: ${rem(14)};
  color: #aaaaaa;
`;

const Image = styled.img`
  margin-right: ${rem(16)};
`;

const IconRow = styled(FlexRowCenterVertical)<{ align: string }>`
  justify-content: ${({ align }) =>
    align === 'center' ? 'center' : 'flex-end'};
`;

const WithThemeRow: any = withTheme(WatchingRow);
export { WithThemeRow as DsiWatchingRow };
